let appJS = {
    Init: function() {
        appJS.Menus();
        appJS.HomepageBackground();
        appJS.AddExternalLinkTarget();
        window.addEventListener('resize', appJS.HomepageBackground);
    },
    Menus: function() {
        let menuButton = document.querySelector('.menu-button');
        menuButton.addEventListener('click', function(e) {
            this.classList.toggle('open');
            document.querySelector('body').classList.toggle('main-menu-open');
            window.scrollTo(0, 0);
        });
        let submenuHolders = document.querySelectorAll('.menu-item-has-children');
        submenuHolders.forEach( submenu => {
            submenu.addEventListener('click', function(e) {
                this.classList.toggle('open');
            });
        });
    },
    HomepageBackground: function() {
        if(document.querySelector('.hero__bg')){
            if (window.innerWidth >= 630){
                if(document.querySelector('.admin-bar')){
                    if (window.innerWidth >= 783){
                        var adminHeight = 32;
                    } else if (window.innerWidth < 783) {
                        var adminHeight = 46;
                    }
                } else {
                    var adminHeight = 0;
                }
                let backgroundHeight = adminHeight + document.querySelector('.site-header').offsetHeight + document.querySelector('.hero').scrollHeight + 'px';
                document.querySelector('.hero__bg').style.height = backgroundHeight;
            } else {
                document.querySelector('.hero__bg').style.removeProperty('height');
            }
        }
    },
    AddExternalLinkTarget: function() {
        let links = Array.from(document.getElementsByTagName('a'));
        links.forEach( link => {
            if (link.host !== window.location.host && !link.hasAttribute("target")) {
                link.setAttribute("target", "_blank");
            }
        });
    },
    LoadMorePosts: function() {
        document.querySelector('.load-more-posts').addEventListener('click', function(){
            document.querySelector('.load-more-posts').classList.toggle('loading');
            let currentPage = parseInt(this.getAttribute('data-page'));
            let newPage = currentPage + 1;
            fetchPosts(newPage);
        });

        function fetchPosts(page){
            fetch(window.location.protocol + '//' +  window.location.hostname +'/wp-json/blog/all-posts?page='+page)
            .then( res => res.json() )
            .then(response => {
                updatePosts(response, page);
            }) 
            .catch(error => console.error('Error:', error));
        }
 
        function updatePosts(response, page){
            if (response.length){
                populateNewPosts(response);
                if (response[0].max !== page){
                    document.querySelector('.load-more-posts').classList.toggle('loading');
                    document.querySelector('.load-more-posts').setAttribute('data-page',page);
                } else {
                    document.querySelector('.load-more-posts').style.display = 'none';
                }
            } else {
                document.querySelector('.load-more-posts').style.display = 'none';
            }
        }

        function populateNewPosts(posts){
            posts.forEach( post => {
                let card = document.createElement("article");
                card.innerHTML = `<article class="blog-card"><a href="${post.url}" class="blog-card__image"><img src="${post.img}" alt="${post.title}"/></a><div class="blog-card__copy"><h3 class="blog-card__heading">${post.title}</h3><div class="blog-card__excerpt">${post.excerpt}</div><a href="${post.url}" class="blog-card__link button">Read more</a></div></article>`;
                document.getElementById("blog-cards").appendChild(card);
            });
        }
    }
    
}
appJS.Init();